/* VH product page (templates/product.vh-2026.json). PRESENTATION ONLY: no cart or customer calls; it never touches the
   theme's buy box form. It only READS the buy box (its price text, its position) for the quick buy bar, and fetches one
   small copy of each pack photo (GET, CDN) to measure the pack's bounds.
   The page is complete with this script off: every element starts visible; motion is added on top. */
(function () {
  'use strict';
  if (window.__vhPdp) return; window.__vhPdp = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function buyBox() { return $('#MainContent > .main-product-section .product-info') || $('#vh-pdp-buy'); }
  function toBuy(e) {
    var t = $('#vh-pdp-buy') || buyBox(); if (!t) return;
    if (e) e.preventDefault();
    t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
  }

  /* Pack bounds + labels. The store photos are square cut-outs with wide transparent margins, so a small CORS copy of the
     photo (the store CDN sends access-control-allow-origin: *) is read once: (1) the pack's own bounds become
     --vhp-bl/--vhp-bt/--vhp-bw/--vhp-bh (fractions of the photo) on every image of this pack, so CSS sizes the PACK like the prototype;
     (2) each label dot is anchored to the pack's silhouette edge at its height, 7% inside (brief 2026-09-30).
     Without it, the photos fit their boxes whole and the dots stay at the defaults written in the markup. */
  function bounds(url, cb) {
    var m = new Image(); m.crossOrigin = 'anonymous';
    m.onload = function () {
      try {
        var w = m.naturalWidth, h = m.naturalHeight, c = document.createElement('canvas'); c.width = w; c.height = h;
        var x = c.getContext('2d'); x.drawImage(m, 0, 0); var d = x.getImageData(0, 0, w, h).data;
        var x0 = w, x1 = -1, y0 = h, y1 = -1;
        for (var y = 0; y < h; y++) for (var i = 0; i < w; i++) if (d[(y * w + i) * 4 + 3] > 40) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y; }
        if (x1 < 0) return cb(null);
        cb({ w: w, h: h, d: d, bl: x0 / w, bt: y0 / h, bw: (x1 + 1 - x0) / w, bh: (y1 + 1 - y0) / h });
      } catch (err) { cb(null); }
    };
    m.onerror = function () { cb(null); };
    m.src = url + (url.indexOf('?') < 0 ? '?' : '&') + 'vhm=1';
  }
  function applyBounds(el, b) {
    // only crop when the margins are worth it (a tight photo stays as it is)
    if (!b || (b.bw > .94 && b.bh > .94)) return;
    el.style.setProperty('--vhp-bl', b.bl.toFixed(4)); el.style.setProperty('--vhp-bt', b.bt.toFixed(4));
    el.style.setProperty('--vhp-bw', b.bw.toFixed(4)); el.style.setProperty('--vhp-bh', b.bh.toFixed(4));
  }
  /* the hero entrance waits for the pack's crop so the photo never shows small and then jumps (2026-10-02) */
  var packReady = false, packWaiters = [];
  function whenPack(fn) { if (packReady) fn(); else packWaiters.push(fn); }
  function packDone() { if (packReady) return; packReady = true; packWaiters.splice(0).forEach(function (f) { f(); }); }
  function packs() {
    var img = $('[data-vh-pdp-pack]');
    if (!img || !img.dataset.measure) packDone();
    setTimeout(packDone, 1200); /* never hold the entrance longer than this */
    if (img && img.dataset.measure) bounds(img.dataset.measure, function (b) {
      document.documentElement.dataset.vhPdpAnchors = b ? 'measured' : 'default';
      if (!b) return packDone();
      if (!b) return;
      applyBounds(img, b); applyBounds(img.parentElement, b);
      $$('[data-vh-pdp-same]').forEach(function (el) { applyBounds(el, b); });
      $$('.vh-pdp-co').forEach(function (co) {
        var row = Math.min(b.h - 1, Math.round((b.bt + parseFloat(co.dataset.ay) / 100 * b.bh) * b.h)), L = -1, R = -1;
        for (var i = 0; i < b.w; i++) if (b.d[(row * b.w + i) * 4 + 3] > 40) { if (L < 0) L = i; R = i; }
        if (L < 0) return;
        var ax = co.dataset.side === 'L' ? (L / b.w - b.bl) / b.bw + 0.07 : ((R + 1) / b.w - b.bl) / b.bw - 0.07;
        co.style.setProperty('--vhp-ax', (ax * 100).toFixed(1) + '%');
      });
      packDone();
    });
    $$('.vh-pdp-pc img[data-measure]').forEach(function (im) { bounds(im.dataset.measure, function (b) { applyBounds(im, b); }); });
  }

  /* photo buttons: pack / extra product photos / scroll to the product video section */
  function thumbs() {
    var stage = $('.vh-pdp-stage'); if (!stage) return;
    stage.addEventListener('click', function (e) {
      var b = e.target.closest('.vh-pdp-thumbs button'); if (!b) return;
      var v = b.dataset.view;
      if (v === 'video') {
        var f = $('#MainContent [class^="ai-video-section-"]') || $('#MainContent [id*="__product_video"]');
        if (f) f.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      $$('.vh-pdp-thumbs button', stage).forEach(function (x) { if (x.dataset.view !== 'video') x.setAttribute('aria-current', String(x === b)); });
      $$('.vh-pdp-scene', stage).forEach(function (f) { f.classList.toggle('on', f.dataset.scene === v); });
      stage.classList.toggle('scene-on', v !== 'pack');
    });
  }

  /* long ingredient names: measure the longest word (+6%) with the REAL font (a hidden nowrap span in the tile, so
     Bricolage's optical size and the U+2011 fallback glyph count; a canvas measure missed both at 390px);
     shrink at most 15%, otherwise span two columns, then fit. Never hyphens:auto. */
  function fitNames() {
    /* Batched (2026-10-02 perf fix): the old version measured each word with its own getBoundingClientRect after a DOM
       write, forcing a full-page layout per word, and ran again on every font load, which froze the page for seconds.
       Now: one write pass (a hidden box of word spans per name), one read pass, one write pass; a second batch only for
       names that go two columns wide. Same rule as before (longest word +6%, shrink at most 15%, else wide, then fit). */
    var tiles = $$('.vh-pdp-tile'); if (!tiles.length) return;
    var items = [];
    tiles.forEach(function (t) {
      t.classList.remove('wide'); var el = $('.nm', t); if (!el || !el.firstChild) return;
      el.style.removeProperty('--vhp-fs'); items.push({ t: t, el: el });
    });
    function measure(list) {
      list.forEach(function (it) { /* one hidden box of word spans per name, created ONCE and kept (never re-inserted:
         every inserted node makes the theme's review observer re-measure all reviews, see copyPrice) */
        var txt = it.el.firstChild.textContent, box = it.el.querySelector(':scope > .vh-pdp-measure');
        if (!box || box.getAttribute('data-src') !== txt) { /* first fit, or the name changed (e.g. Weglot): one insert */
          var fresh = document.createElement('span'); fresh.className = 'vh-pdp-measure'; fresh.setAttribute('aria-hidden', 'true'); fresh.setAttribute('data-src', txt);
          txt.split(/\s+/).forEach(function (w) { if (!w) return; var sp = document.createElement('span'); sp.textContent = w; sp.style.cssText = 'display:block;width:max-content'; fresh.appendChild(sp); });
          if (box) it.el.replaceChild(fresh, box); else it.el.appendChild(fresh);
          box = fresh;
        }
        it.box = box;
      });
      list.forEach(function (it) { /* reads only: a single layout for the whole batch */
        var mx = 0; for (var c = it.box.firstChild; c; c = c.nextSibling) mx = Math.max(mx, c.getBoundingClientRect().width);
        it.widest = 1.06 * mx; it.base = parseFloat(getComputedStyle(it.el).fontSize); it.cw = it.el.clientWidth;
        it.multi = getComputedStyle(it.t.parentElement).gridTemplateColumns.split(' ').length > 1;
      });
    }
    measure(items);
    var over = items.filter(function (it) { return it.widest > it.cw; });
    var wide = over.filter(function (it) { return it.cw / it.widest < 0.85 && it.multi; });
    wide.forEach(function (it) { it.t.classList.add('wide'); });
    if (wide.length) measure(wide);
    over.forEach(function (it) {
      if (it.widest <= it.cw) return;
      it.el.style.setProperty('--vhp-fs', Math.max(12, Math.floor(it.base * it.cw / it.widest * 10) / 10) + 'px');
    });
  }
  var fitT = 0;
  function queueFit() { clearTimeout(fitT); fitT = setTimeout(function () { requestAnimationFrame(fitNames); }, 150); }

  /* quick buy bar (desktop): shows once the buy box has scrolled away, hides at the closing call to action */
  function quickBar() {
    var bar = $('[data-vh-pdp-mbar]'); if (!bar) return;
    var priceEl = $('[data-vh-pdp-mbar-price]', bar);
    var desk = window.matchMedia('(min-width: 901px)');
    function copyPrice() {
      var p = $('#MainContent > .main-product-section .product-price .product-actual-price');
      if (!p || !priceEl) return;
      /* write only when it changed: a text write adds a node, and the theme's review MutationObserver (layout/theme.liquid
         enhanceReviews) answers every added node with a forced layout. Writing it on every scroll frame made scrolling lag. */
      var v = p.textContent.replace(/\s+/g, ' ').trim();
      if (priceEl.textContent !== v) priceEl.textContent = v;
    }
    function tick() {
      var b = buyBox(), f = $('.vh-pdp-final');
      if (!desk.matches || !b) { bar.classList.remove('show'); return; }
      var past = b.getBoundingClientRect().bottom < 0, atEnd = f && f.getBoundingClientRect().top < innerHeight;
      if (past && !atEnd) copyPrice();
      bar.classList.toggle('show', past && !atEnd);
    }
    bar.hidden = false; copyPrice();
    addEventListener('scroll', tick, { passive: true }); addEventListener('resize', tick); tick();
  }

  /* Motion WITHOUT GSAP: this theme bundles its own GSAP + ScrollTrigger (assets/foundation.js) and runs Lenis on desktop;
     on phones its animation-initialize.js kills every ScrollTrigger, clears the global timeline and strips every inline
     style except custom properties. So: CSS animations started by a class, IntersectionObserver reveals, rAF scroll
     effects, and inline styles only as custom properties. Every element is visible before any of this runs. */
  function onceVisible(els, fn, margin) {
    if (!('IntersectionObserver' in window)) { els.forEach(fn); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fn(e.target); } }); }, { rootMargin: margin || '0px 0px -12% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  function countUp(el) {
    var raw = el.dataset.to || ''; if (!/^\d+(\.\d+)?$/.test(raw)) return;
    var to = parseFloat(raw), dec = (raw.split('.')[1] || '').length, t0 = 0;
    function step(ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / 1600), e = 1 - Math.pow(1 - k, 3);
      var txt = k < 1 ? (to * e).toFixed(dec) : raw; /* update the text node's data: a characterData change, not an added node (see copyPrice) */
      if (el.firstChild && el.firstChild.nodeType === 3 && !el.firstChild.nextSibling) el.firstChild.data = txt; else el.textContent = txt;
      if (k < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  function motion() {
    if (RM) return;
    var hero = $('.vh-pdp-hero'), stage = $('.vh-pdp-stage');
    if (hero) {
      var text = $('.vh-pdp-word text');
      try { var len = text.getComputedTextLength() * 2.2; if (len) $('.vh-pdp-word').style.setProperty('--vhp-len', Math.round(len)); } catch (e) {}
      whenPack(function () { requestAnimationFrame(function () { hero.classList.add('vh-pdp-go'); }); });
    }
    document.documentElement.classList.add('vh-pdp-motion');
    var tilt = $('.vh-pdp-tilt');
    if (stage && tilt && window.matchMedia('(hover: hover)').matches) {
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        tilt.classList.remove('rest'); tilt.style.setProperty('--vhp-ry', (x * 10).toFixed(2) + 'deg'); tilt.style.setProperty('--vhp-rx', (-y * 7).toFixed(2) + 'deg');
      });
      stage.addEventListener('pointerleave', function () { tilt.classList.add('rest'); tilt.style.setProperty('--vhp-ry', '0deg'); tilt.style.setProperty('--vhp-rx', '0deg'); });
    }
    // reveals and count-ups (once)
    $$('.vh-pdp-proof,.vh-pdp-formula,.vh-pdp-cinema').forEach(function (el) { el.classList.add('vh-pdp-rv'); });
    onceVisible($$('.vh-pdp-rv'), function (el) { el.classList.add('vh-pdp-in'); });
    onceVisible($$('.vh-pdp-count'), countUp);
    // scroll-linked: pack parallax, cinema push-in, benefit panels + rail (desktop)
    var pouch = $('.vh-pdp-pouch'), cin = $('.vh-pdp-cinema'), panels = $('.vh-pdp-panels'), ps = panels ? $$('.p', panels) : [];
    var bimg = $('[data-vh-pdp-bvis]'), rail = $('.vh-pdp-ben .rail'), cur = -1, ticking = false;
    var ROT = [-6, 4, -2], SC = [1, 1.06, 1.12];
    if (panels && ps.length) panels.classList.add('live');
    function frame() {
      ticking = false; var vh = innerHeight;
      if (pouch && hero) { var hr = hero.getBoundingClientRect(), p = Math.min(1, Math.max(0, -hr.top / Math.max(1, hr.height))); pouch.style.setProperty('--vhp-py', p.toFixed(4)); }
      if (cin) { var cr = cin.getBoundingClientRect(), q = Math.min(1, Math.max(0, (vh - cr.top) / (vh + cr.height))); cin.style.setProperty('--vhp-cz', (1.25 - .25 * q).toFixed(4)); }
      if (ps.length) {
        var desk = innerWidth > 900; panels.classList.toggle('live', desk);
        if (desk) {
          var line = vh * .6, act = -1;
          ps.forEach(function (el, i) { var r = el.getBoundingClientRect(); if (r.top <= line && r.bottom > line) act = i; });
          if (act < 0) act = ps[0].getBoundingClientRect().top > line ? 0 : ps.length - 1;
          if (act !== cur) { cur = act; ps.forEach(function (x, i) { x.classList.toggle('on', i === act); });
            if (bimg) { bimg.style.setProperty('--vhp-br', (ROT[act] || 0) + 'deg'); bimg.style.setProperty('--vhp-bs', SC[act] || 1); } }
          if (rail) { var a = ps[0].getBoundingClientRect().top, b = ps[ps.length - 1].getBoundingClientRect().bottom;
            rail.style.setProperty('--vhp-rail', Math.min(1, Math.max(0, (line - a) / Math.max(1, b - a))).toFixed(4)); }
        }
      }
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    addEventListener('scroll', req, { passive: true }); addEventListener('resize', req); frame();
    var mag = $('.vh-pdp-mag');
    if (mag && window.matchMedia('(hover: hover)').matches) {
      mag.addEventListener('pointermove', function (e) { var r = mag.getBoundingClientRect(); mag.classList.remove('rest');
        mag.style.setProperty('--vhp-mx', ((e.clientX - r.left - r.width / 2) * .3).toFixed(1) + 'px'); mag.style.setProperty('--vhp-my', ((e.clientY - r.top - r.height / 2) * .4).toFixed(1) + 'px'); });
      mag.addEventListener('pointerleave', function () { mag.classList.add('rest'); mag.style.setProperty('--vhp-mx', '0px'); mag.style.setProperty('--vhp-my', '0px'); });
    }
  }

  function init() {
    if (!$('.vh-pdp')) return;
    packs(); thumbs(); quickBar(); motion();
    $$('[data-vh-pdp-tobuy]').forEach(function (a) { a.addEventListener('click', toBuy); });
    fitNames();
    // re-fit once the web fonts arrive (fonts.ready can resolve before Bricolage starts loading, so font loads and window
    // load also trigger it), coalesced: bursts of font loads and resizes run ONE fit 150ms after the last event
    if (document.fonts) { if (document.fonts.ready) document.fonts.ready.then(queueFit); if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', queueFit); }
    addEventListener('load', function () { queueFit(); setTimeout(queueFit, 1500); });
    var grid = $('.vh-pdp-tiles'), lastW = 0;
    if (grid && window.ResizeObserver) new ResizeObserver(function (es) { var w = Math.round(es[0].contentRect.width); if (w !== lastW) { lastW = w; queueFit(); } }).observe(grid);
    addEventListener('resize', queueFit);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Subscribe & save inside the Seal option (prototype: chip + struck price in the option, no separate box).
   PRESENTATION ONLY: reads the savings line rendered by snippets/vh-pdp-buybox.liquid (part 'savings') and adds a chip and
   the struck one-time price into the matching Seal option. No input, selection or form is touched. If Seal's markup is
   not found, nothing changes and the separate savings box stays as the fallback. Re-applied when Seal re-renders. */
(function () {
  function apply() {
    var src = document.querySelector('.main-product-section .vh-pdp-save[data-vh-plan]');
    var box = document.querySelector('.main-product-section .sls-purchase-options-container');
    if (!src || !box) return false;
    var plan = (src.getAttribute('data-vh-plan') || '').trim().toLowerCase();
    var opt = null;
    box.querySelectorAll('.sls-option-container').forEach(function (o) {
      var n = o.querySelector('.sls-selling-plan-group-name');
      if (n && n.textContent.trim().toLowerCase() === plan) opt = o;
    });
    if (!opt) return false;
    var name = opt.querySelector('.sls-selling-plan-group-name');
    var below = opt.querySelector('.sls-price-below');
    if (name && !opt.querySelector('.vh-pdp-sls-chip')) {
      var chip = document.createElement('span');
      chip.className = 'vh-pdp-sls-chip';
      chip.textContent = src.getAttribute('data-vh-chip');
      name.insertAdjacentElement('afterend', chip);
    }
    if (below && !below.querySelector('.vh-pdp-sls-was')) {
      var was = document.createElement('s');
      was.className = 'vh-pdp-sls-was';
      was.textContent = src.getAttribute('data-vh-was');
      below.appendChild(was);
    }
    document.documentElement.classList.add('vh-pdp-sls-on');
    return true;
  }
  function start() {
    var tries = 0;
    var t = setInterval(function () { if (apply() || ++tries > 40) clearInterval(t); }, 250);
    var host = document.querySelector('.main-product-section');
    if (host && window.MutationObserver) {
      var busy = false;
      new MutationObserver(function () { if (busy) return; busy = true; requestAnimationFrame(function () { apply(); busy = false; }); })
        .observe(host, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Reviews without Judge.me's script (2026-10-02, perf: Judge.me's core embed is off, as on live). PRESENTATION ONLY.
   The page already carries Judge.me's server-rendered widget (average, histogram, first 5 reviews). This:
   - keeps each card's stars: the theme's enhanceReviews (layout/theme.liquid) rebuilds every review header but looks for
     .jdgm-rev__stars (the server markup uses .jdgm-rev__rating), so it dropped them. This runs first (deferred script,
     before DOMContentLoaded handlers) and moves the rating to the card itself, where that rebuild doesn't touch it;
   - writes the review date (Judge.me's script normally fills the empty <time>);
   - replaces the page links (dead without Judge.me's script) with "Show more reviews", which GETs the next 5 from
     Judge.me's public widget feed (the same request its own script makes) and appends them, prepared the same way.
   Nothing is posted and no customer data is sent. Write a review / Ask a question are hidden in CSS (Bronson). */
(function () {
  var I18N = {}; /* strings from sections/vh-pdp-stage.liquid (#vh-pdp-i18n); the English is the fallback */
  try { I18N = JSON.parse((document.getElementById('vh-pdp-i18n') || {}).textContent || '{}'); } catch (e) {}
  var widget = document.querySelector('#MainContent .jdgm-review-widget');
  if (!widget || window.jdgmSettings) return; /* Judge.me's own script is running: leave its widget alone */
  var lang = (document.documentElement.lang || 'es').toLowerCase().indexOf('en') === 0 ? 'en-US' : 'es-MX';
  function prep(rev) {
    if (window.vhRevPrep) return window.vhRevPrep(rev); /* sections/vh-skin.liquid: same steps, run while the page is parsed */
    if (rev.getAttribute('data-vh-rev')) return; rev.setAttribute('data-vh-rev', '1');
    var rating = rev.querySelector('.jdgm-rev__header .jdgm-rev__rating');
    if (rating) rev.insertBefore(rating, rev.firstChild);
    var t = rev.querySelector('.jdgm-rev__timestamp');
    if (t && !t.textContent.trim()) {
      var d = new Date(t.getAttribute('datetime') || '');
      if (!isNaN(d)) { t.textContent = d.toLocaleDateString(lang, { day: '2-digit', month: '2-digit', year: 'numeric' }); t.classList.remove('jdgm-spinner'); }
    }
  }
  var list = widget.querySelector('.jdgm-rev-widg__reviews');
  if (!list) return;
  Array.prototype.forEach.call(list.querySelectorAll('.jdgm-rev'), prep);
  var widg = widget.querySelector('.jdgm-rev-widg'), pag = widget.querySelector('.jdgm-paginate');
  var total = parseInt(widg && widg.getAttribute('data-number-of-reviews'), 10) || 0;
  var pid = widget.getAttribute('data-product-id'), shop = (window.Shopify && window.Shopify.shop) || '';
  var perPage = parseInt(pag && pag.getAttribute('data-per-page'), 10) || 5, page = 1;
  var feed = (pag && pag.getAttribute('data-url')) || 'https://api.judge.me/reviews/reviews_for_widget';
  if (!pid || !shop || list.querySelectorAll('.jdgm-rev').length >= total) return;
  var btn = document.createElement('button');
  btn.type = 'button'; btn.className = 'vh-pdp-revmore'; btn.textContent = I18N.showMore || 'Show more reviews';
  (pag || list).insertAdjacentElement('afterend', btn);
  btn.addEventListener('click', function () {
    if (btn.disabled) return; btn.disabled = true; btn.textContent = I18N.loading || 'Loading…';
    var q = '?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&page=' + (page + 1) + '&per_page=' + perPage + '&product_id=' + encodeURIComponent(pid);
    fetch(feed + q, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw r.status; return r.json(); }).then(function (j) {
      var tpl = document.createElement('template'); tpl.innerHTML = (j && j.html) || '';
      var revs = tpl.content.querySelectorAll('.jdgm-rev'), frag = document.createDocumentFragment();
      Array.prototype.forEach.call(revs, function (r) { prep(r); frag.appendChild(r); });
      list.appendChild(frag); page += 1; /* one insert: one pass of the theme's (debounced) review observer */
      var shown = list.querySelectorAll('.jdgm-rev').length;
      if (!revs.length || shown >= total) btn.remove(); else { btn.disabled = false; btn.textContent = I18N.showMore || 'Show more reviews'; }
    }).catch(function () { btn.disabled = false; btn.textContent = I18N.showMore || 'Show more reviews'; });
  });
})();

/* Reviews folded behind one bar (Bronson 2026-10-02: "fold it closed behind a 'See all 51 reviews' bar that opens on tap").
   PRESENTATION ONLY. The widget stays laid out while folded (height 0 + visibility hidden, not display:none) so the
   theme's enhanceReviews can still measure long reviews and add Read More. The buy box's "N reviews" link opens it.
   A product with no reviews hides the section (Write a review is hidden, so it would be empty). */
(function () {
  var I18N = {};
  try { I18N = JSON.parse((document.getElementById('vh-pdp-i18n') || {}).textContent || '{}'); } catch (e) {}
  var w = document.querySelector('#MainContent .jdgm-review-widget'), rw = w && w.querySelector('.jdgm-rev-widg');
  if (!rw) return;
  var n = parseInt(rw.getAttribute('data-number-of-reviews'), 10) || 0, avg = parseFloat(rw.getAttribute('data-average-rating')) || 0;
  if (!n) { w.classList.add('vh-rev-none'); return; }
  if (!rw.id) rw.id = 'vh-rev-body';
  var label = function (open) { return open ? (I18N.hideReviews || 'Hide reviews') : (n === 1 ? (I18N.seeAllOne || 'See all %n review') : (I18N.seeAllOther || 'See all %n reviews')).replace('%n', n); };
  var stars = '';
  if (avg >= 4) { /* site rule: no star rating shown under 4 */
    for (var i = 1; i <= 5; i++) stars += '<i class="' + (avg >= i - 0.25 ? 'on' : avg >= i - 0.75 ? 'half' : 'off') + '"></i>';
    stars = '<span class="st" aria-hidden="true">' + stars + '</span><b>' + avg.toFixed(1) + '</b>';
  }
  var bar = document.createElement('button');
  bar.type = 'button'; bar.className = 'vh-rev-bar'; bar.setAttribute('aria-controls', rw.id); bar.setAttribute('aria-expanded', 'false');
  bar.innerHTML = stars + '<span class="t">' + label(false) + '</span><span class="ch" aria-hidden="true"></span>';
  w.insertBefore(bar, w.firstChild); w.classList.add('vh-rev-closed');
  function set(open) {
    w.classList.toggle('vh-rev-closed', !open); bar.setAttribute('aria-expanded', String(open));
    bar.querySelector('.t').textContent = label(open);
  }
  bar.addEventListener('click', function () { set(w.classList.contains('vh-rev-closed')); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a[href="#judgeme_product_reviews"]')) set(true); }, true);
  if (location.hash === '#judgeme_product_reviews') set(true);
})();
